import { datadogLogs } from '@datadog/browser-logs';
import { ImpButton, ImpSpacer } from '@imprint-payments/imprint-ui';
import { useEffect } from 'react';

import { EVENT } from '../../analytics/analyticsConsts';
import { useImpState } from '../../app/hooks';
import ErrorModal from '../../components/errorModal/ErrorModal';
import { HeaderHandler } from '../../components/HeaderHandler/HeaderHandler';
import {
  emitSDKEvent,
  emitSDKResult,
  isSDK,
  SDK_EVENTS,
  SDK_RESULTS,
  useSDKContext,
} from '../../utils/sdk';
import styles from './Error.module.css';

export default function Error() {
  const { language, merchantData } = useImpState();
  const { errorCode } = useSDKContext();

  useEffect(() => {
    datadogLogs.logger.error(EVENT.ERROR_PAGE_VIEWED);
  }, []);

  const renderBackToPartnerButton = () => {
    const merchantName = merchantData.rewardDetails.merchantName;
    return (
      <ImpButton
        variant="primary"
        buttonStyle="branded"
        onClick={() => {
          emitSDKResult({
            result: SDK_RESULTS.ERROR,
            errorCode,
          });
          emitSDKEvent({
            event: SDK_EVENTS.CLOSED,
          });
        }}
      >
        {merchantName ? language.backTo + merchantName : language.goBackBtn}
      </ImpButton>
    );
  };

  return (
    <div className={styles.outerContainer}>
      <HeaderHandler />
      <div className={styles.contentWrapper}>
        <ErrorModal
          title={language.errorTitle}
          subline={language.errorSubline}
        />
        {isSDK() && (
          <>
            <ImpSpacer height="xl" />
            {renderBackToPartnerButton()}
          </>
        )}
      </div>
    </div>
  );
}
